
export default {
  vessel: {
    title: {
      fontSize: '3xl',
      fontWeight: 'bold'
    },
    service: {
      fontSize: 'md',
      fontWeight: 'semibold'
    },
    icon: {
      backgroundColor: 'primary',
      padding: 'xs',
      borderRadius: 'full'
    }
  },
  async asyncData({ $content, app: { i18n: { locale }, $seoMeta } }) {
    const page = await $content(locale, 'pages/about').fetch()
    const services = await $content(locale, 'data/services').fetch()

    $seoMeta.update($seoMeta.page(page.seo))

    return {
      page,
      services
    }
  },
  computed: {
    attachments() {
      const images = this.page.images
      const items = []

      images.forEach((item) => {
        items.push({
          src: item,
          title: this.page.title,
          fit: 'cover'
        })
      })

      return items
    }
  }
}
